import Mixpanel from 'mixpanel-browser';

const MIXPANEL_TOKEN = '5340b4047861d2fb55480b8f69ba270d';

export {
    Mixpanel,
    MIXPANEL_TOKEN
};